import { Loader } from "./Loader";
import { SceneNode } from "./SceneNode";

export class Scene {

    private nodeMap: Map<string, SceneNode>;
    public rootNodes: SceneNode[];

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let listResult = loader.util.readIdentityList<SceneNode>(dataView, offset);
        this.rootNodes = listResult.items;
        offset = listResult.offset;

        this.buildNodeLookup();
    }

    public lookupNode(sid: string): SceneNode {
        if (this.nodeMap.has(sid)) {
            return this.nodeMap.get(sid);
        } else {
            return null;
        }
    }

    public getControllerNodes(): SceneNode[] {
        let result = new Array<SceneNode>();

        let getControllers = (node: SceneNode) => {
            if (node.subType === 'controller') {
                result.push(node);
            }

            node.childNodes.forEach(getControllers);
        };

        this.rootNodes.forEach(getControllers);

        return result;
    }

    private buildNodeLookup(): void {
        let map = new Map<string, SceneNode>();
        let buildMap = (node: SceneNode) => {

            node.visualScene = this;

            // TODO: Which of these is really used?
            if (node.sid) {
                map.set(node.sid, node);
            }
            if (node.id) {
                map.set(node.id, node);
            }
            if (node.name) {
                map.set(node.name, node);
            }

            node.childNodes.forEach(buildMap);
        };

        this.rootNodes.forEach(buildMap);

        this.nodeMap = map;
    }
}
